import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Heading, Text } from '@frontend/design-system';
import { VerticalGrid } from '../../../components/payment-methods/containers/vertical-grid';

export type PaymentMethodsNoGatewayPlaceholderProps = {
  title?: React.ReactNode;
  text?: React.ReactNode;
  onClose?: () => void;
  showCloseButton?: boolean;
};
export const PaymentMethodsNoGatewayPlaceholder = ({
  title,
  text,
  onClose,
  showCloseButton,
}: PaymentMethodsNoGatewayPlaceholderProps) => {
  const { t } = useTranslation('payments');

  return (
    <VerticalGrid
      data-testid='payment-methods-no-gateway-placeholder'
      className='payment-methods__no-gateway-placeholder'
      css={{ padding: theme.spacing(0, 4) }}
    >
      <div css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <Heading level={2}>{title ?? t('Payment Methods on File')}</Heading>
        </div>
        <div>
          {(showCloseButton === true || typeof showCloseButton === 'undefined') && onClose && (
            <Button variant='secondary' iconName='x-small' onClick={onClose}></Button>
          )}
        </div>
      </div>
      {text ?? (
        <>
          <Text>
            {t('No payment gateway is configured for this merchant. If this is not the case, please contact support.')}
          </Text>
        </>
      )}
    </VerticalGrid>
  );
};
